import toast from 'react-hot-toast'

import { useMutation, useQueryClient } from '@fv/client-core'
import type { ConfirmPickupRequest } from '@fv/models'

import { carrierFetch } from '@/utils/carrierFetch'

import type { PublicShipment } from './types'

const setPickupNumber =
  (loadId: string) =>
  async (dto: ConfirmPickupRequest): Promise<PublicShipment> => {
    if (!dto.token) throw new Error('No authentication token provided.')

    const proNumber = dto.proNumber?.trim()
    return carrierFetch<PublicShipment>(`/loads/${loadId}/pickup-number`, {
      method: 'POST',
      body: {
        pickupNumber: dto.pickupNumber.trim(),
        token: dto.token,
        ...(proNumber && { proNumber }),
      },
    })
  }

export function useConfirmPickup(loadId: string) {
  const queryClient = useQueryClient()

  return useMutation(setPickupNumber(loadId), {
    onError: (e: { message: string }) => {
      toast.error(
        e?.message ??
          'Unable to confirm pickup, please contact support@freightview.com for assistance.',
      )
    },
    onSuccess: (shipment, vars) => {
      queryClient.setQueryData(['public', loadId, vars.token], shipment)
      toast.success('Pickup confirmed!')
    },
  })
}
